export const LOAD_PORTCO_SETTING_VALUE_BY_KEY_REQUEST = 'setting/LOAD_PORTCO_SETTING_VALUE_BY_KEY_REQUEST';
export const LOAD_PORTCO_SETTING_VALUE_BY_KEY_SUCCESS = 'setting/LOAD_PORTCO_SETTING_VALUE_BY_KEY_SUCCESS';
export const LOAD_PORTCO_SETTING_VALUE_BY_KEY_FAILURE = 'setting/LOAD_PORTCO_SETTING_VALUE_BY_KEY_FAILURE';

export const UPDATE_PORTCO_SETTING_BY_KEY_REQUEST = 'setting/UPDATE_PORTCO_SETTING_BY_KEY_REQUEST';
export const UPDATE_PORTCO_SETTING_BY_KEY_SUCCESS = 'setting/UPDATE_PORTCO_SETTING_BY_KEY_SUCCESS';
export const UPDATE_PORTCO_SETTING_BY_KEY_FAILURE = 'setting/UPDATE_PORTCO_SETTING_BY_KEY_FAILURE';
